module.exports = __webpack_public_path__ + "static/img/he14.3a5dd39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he14.png
// module id = iAcp
// module chunks = 1